export default __webpack_public_path__ + "static/media/Account_Delivery_Role.6dd6525b.svg";